// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__1RTVH","modalBody":"MealsPop_modalBody__YxQRq"};